// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type CautionsListType = {
  cautions: Array<string> | null | undefined;
};

const CautionsList = ({ cautions }: CautionsListType) => {
  const { t } = useTranslation();

  if (!cautions || cautions.length === 0) {
    return <Typography fontSize="12px">{t("N/A")}</Typography>;
  }

  return (
    <Box
      component="ul"
      sx={{
        m: 0,
        p: 0,
        listStyle: "none",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      {cautions.map((code) => (
        <Box component="li" key={code}>
          <Typography sx={{ fontSize: "12px" }}>{t(code)}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CautionsList;
